import BaseModel from './BaseModel';

export default class HeartRate extends BaseModel {
  constructor(public value: number) {
    super();
  }

  toString(): string {
    return `HR: ${this.value}`;
  }

  toJSON() {
    return {
      value: this.value,
    };
  }
}
